export const MAX_PAGE_SIZE = 999999999;

export const LABEL_DATA_FORMAT = 'PNG';
export const LABEL_SIZE = '4x6';
export const LABEL_DPI = 203;
